var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { get } from 'lodash';
import { PageHeader, PageHeaderDefaultProps } from './page-header';
import { ContentEntityRichTitle } from './content-entity-rich-title';
import { ContentEntityRichSubtitle } from './content-entity-rich-subtitle';
import { ContentEntityContent } from './content-entity-content';
import { SliceLayout } from './slice-layout';
import { classNames } from '../../utils/cn';
var cls = classNames('page-layout-standard');
export var PageLayoutStandardDefaultProps = {}; // -------- Child Component Props -------->
// -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var HeaderStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var TitleStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: 3em;\n    line-height: 1em;\n    font-family: ", ";\n    font-weight: 300;\n    color: ", ";\n\n    strong, b {\n      font-weight: 500;\n      color: inherit;\n    }\n\n    margin-bottom: ", ";\n  "], ["\n    font-size: 3em;\n    line-height: 1em;\n    font-family: ", ";\n    font-weight: 300;\n    color: ", ";\n\n    strong, b {\n      font-weight: 500;\n      color: inherit;\n    }\n\n    margin-bottom: ", ";\n  "])), theme.FONT('serif'), theme.COLOR('light'), theme.UNIT(14)),
  tablet: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: 4em;\n  "], ["\n    font-size: 4em;\n  "]))),
  desktop: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-size: 5em;\n  "], ["\n    font-size: 5em;\n  "])))
});
var SubtitleStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-size: 1.1em;\n    color: ", ";\n    margin-bottom: ", ";\n  "], ["\n    font-size: 1.1em;\n    color: ", ";\n    margin-bottom: ", ";\n  "])), theme.COLOR('light'), theme.UNIT(6)),
  tablet: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    font-size: 1.2em;\n  "], ["\n    font-size: 1.2em;\n  "]))),
  desktop: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    font-size: 1.4em;\n  "], ["\n    font-size: 1.4em;\n  "])))
});
var ContentStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ContentTitleStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    font-size: 2em;\n    line-height: 1.05em;\n    margin-bottom: 0.3em;\n    padding: 0;\n    font-family: ", ";\n  "], ["\n    font-size: 2em;\n    line-height: 1.05em;\n    margin-bottom: 0.3em;\n    padding: 0;\n    font-family: ", ";\n  "])), theme.FONT('serif')),
  tablet: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    font-size: 3em;\n  "], ["\n    font-size: 3em;\n  "]))),
  desktop: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    font-size: 4em;\n  "], ["\n    font-size: 4em;\n  "])))
});
var ContentSubtitleStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    font-family: ", ";\n  "], ["\n    font-family: ", ";\n  "])), theme.FONT('serif'))
});
var ContentTitlesStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme.UNIT(4)),
  tablet: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme.UNIT(6)),
  desktop: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme.UNIT(8))
});
var BannerTitlesStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Header: styled(PageHeader).attrs(cls.attr('header'))(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  BannerTitles: styled.div.attrs(cls.attr('banner-titles'))(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), BannerTitlesStyles),
  Title: styled(ContentEntityRichTitle).attrs(cls.attr('title'))(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Subtitle: styled(ContentEntityRichSubtitle).attrs(cls.attr('subtitle'))(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), SubtitleStyles),
  ContentTitles: styled.div.attrs(cls.attr('content-titles'))(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), ContentTitlesStyles),
  ContentTitle: styled(ContentEntityRichTitle).attrs(cls.attr('content-title'))(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), ContentTitleStyles),
  ContentSubtitle: styled(ContentEntityRichSubtitle).attrs(cls.attr('content-subtitle'))(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), ContentSubtitleStyles),
  Content: styled(ContentEntityContent).attrs(cls.attr('content'))(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles)
};
export var PageLayoutStandard = function PageLayoutStandard(props) {
  var className = props.className,
      entity = props.entity,
      slices = props.slices,
      children = props.children,
      afterBannerTitles = props.afterBannerTitles,
      beforeBannerTitles = props.beforeBannerTitles,
      bannerTitles = props.bannerTitles;

  var headerProps = __assign(__assign({}, PageHeaderDefaultProps), props.headerProps || {});

  var banners = entity.banners || [];
  var hasBanners = banners.length > 0;
  var hasTitles = entity.title || entity.subtitle;
  var hasContent = !!get(entity, 'content.text');
  var Header = props.headerComponent || My.Header;
  return React.createElement(My.Container, {
    className: className
  }, React.createElement(Header, __assign({
    entity: entity
  }, headerProps), hasBanners && React.createElement(My.BannerTitles, null, beforeBannerTitles, bannerTitles || React.createElement(React.Fragment, null, React.createElement(My.Title, {
    entity: entity
  }), React.createElement(My.Subtitle, {
    entity: entity
  })), afterBannerTitles)), !hasBanners && hasTitles && React.createElement(SliceLayout, {
    verticalPadding: 'none',
    entity: entity
  }, React.createElement(My.ContentTitles, null, React.createElement(My.ContentTitle, {
    entity: entity
  }), React.createElement(My.ContentSubtitle, {
    entity: entity
  }))), hasContent && React.createElement(SliceLayout, {
    verticalPadding: 'small',
    entity: entity
  }, React.createElement(My.Content, {
    entity: entity
  })), slices, children);
};
PageLayoutStandard.defaultProps = PageLayoutStandardDefaultProps;
PageLayoutStandard.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26;